import {
	getDefaultNerveClientConfig,
	INerveClientConfig,
} from '@nervejs/common';

export interface IConfig extends INerveClientConfig {}

export const DEFAULT_CONFIG: IConfig = {
	...getDefaultNerveClientConfig(),
};

export let CONFIG = { ...DEFAULT_CONFIG };

export const setConfig = (config: IConfig) => CONFIG = { ...DEFAULT_CONFIG, ...config } as IConfig;
export const getConfig = () => CONFIG;
